import { createFileRoute } from '@tanstack/react-router';
import { DateTime } from 'luxon';
// import FluentEmojiBug from '~icons/fluent-emoji/bug';
// import FluentEmojiRocket from '~icons/fluent-emoji/rocket';
import TablerIconArrowLeft from '~icons/tabler/arrow-left';
import TablerIconHome from '~icons/tabler/home';

// import { cn } from '#/utils/classnames';
import { Container, Stack, Typography } from 'gooey';
import { GlowCard } from '#/components/design';
import { ButtonLink } from '#/components/links';
import { Page } from '#/components/pages/page';
import fx from '#/fx';
import { Content } from '#/lib/content';
import { canonicalLinkTag, seo } from '#/lib/head';
// import React from 'react';
// import type { ChangeLogEntry } from '#/content';
import { ChangelogEntryAuthor } from './-components/changelog-entry-author';

export const Route = createFileRoute('/_main/changelog/entries/$id')({
  loader: async ({ params }) => {
    const entry = await fx.getChangelogEntry({
      data: {
        id: params.id,
      },
    });
    return { entry };
  },
  head: ({ loaderData, match }) => {
    return {
      meta: seo({
        title: loaderData?.entry.seo.title ?? 'Changelog Entry',
        description: loaderData?.entry.seo.description ?? 'A changelog entry from the Joggr team.',
        image: loaderData?.entry.seo.image,
        url: match.pathname,
      }),
      links: [canonicalLinkTag(match.pathname)],
    };
  },
  component: ChangelogEntryPage,
});

function ChangelogEntryPage() {
  const { entry } = Route.useLoaderData();
  return (
    <Page>
      <Stack direction='column' spacing={1} alignItems='center' className='mt-8'>
        <Container maxWidth='md' className='px-2'>
          <Stack alignItems='center' justifyContent='center' spacing={2}>
            <Typography variant='caption'>
              {DateTime.fromJSDate(new Date(entry.date)).toLocaleString(DateTime.DATE_SHORT)}
            </Typography>
            <div className='text-center mb-4'>
              <Typography variant='h2' component='h1' gutterBottom>
                {entry.title}
              </Typography>
              <Typography className='text-gray-400'>{entry.summary}</Typography>
            </div>
            <div>
              <ChangelogEntryAuthor author={entry.author} size='medium' />
            </div>
          </Stack>
        </Container>
        <Container maxWidth='md' className='mt-8'>
          <Content content={entry.content} format='mdx' styling='prose' />
        </Container>
        {/* {entry.fullLog.length > 0 && (
          <Container maxWidth='md'>
            <Divider className='my-8' />
            <Typography variant='h3' component='h2' gutterBottom>
              Full Changelog
            </Typography>
            <Typography variant='body1' component='p' gutterBottom>
              Below is the full list of enhancements and defects for this release.
            </Typography>
            <Stack direction='column' spacing={1}>
              <ul>
                {entry.fullLog.map((item) => (
                  <li key={item.title} className='py-2 first:pt-0 last:pb-0'>
                    <ChangelogEntryItem item={item} />
                  </li>
                ))}
              </ul>
            </Stack>
          </Container>
        )} */}
      </Stack>
      <Container>
        <GlowCard
          border='top'
          glowHeight='8'
          className='min-h-32 w-full mt-16 md:w-2/3 lg:w-1/2 mx-auto'
        >
          <Stack
            direction={{ xs: 'column', sm: 'row' }}
            spacing={2}
            alignItems='center'
            justifyContent='stretch'
          >
            <div className='w-full'>
              <ButtonLink
                fullWidth
                variant='outlined'
                to='/changelog'
                startIcon={<TablerIconArrowLeft />}
              >
                Back to Changelog
              </ButtonLink>
            </div>
            <div className='w-full'>
              <ButtonLink fullWidth variant='outlined' to='/' startIcon={<TablerIconHome />}>
                Go to Home
              </ButtonLink>
            </div>
          </Stack>
        </GlowCard>
      </Container>
    </Page>
  );
}

/*
|------------------
| Internals
|------------------
*/

// function ChangelogEntryItem({ item }: { item: ChangeLogEntry['fullLog'][number] }) {
//   const icon = React.useMemo(() => {
//     const className = 'size-8';
//     if (item.type === 'enhancement') {
//       return <FluentEmojiRocket className={className} />;
//     }
//     return <FluentEmojiBug className={className} />;
//   }, [item.type]);
//   return (
//     <div
//       className={cn('flex items-center gap-4 hover:animate-shine', {
//         'cursor-duck': item.type === 'enhancement',
//         'cursor-heart': item.type === 'defect',
//       })}
//     >
//       <div>{icon}</div>
//       <div>
//         <Typography variant='subtitle1' className='font-bold' component='h4'>
//           {item.title}
//         </Typography>
//         <Typography variant='body2' component='p'>
//           {item.description}
//         </Typography>
//       </div>
//     </div>
//   );
// }
